import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import AccountUsersTableComponent from 'webapp/components/account/users/table';

export default class SettingsUsersRouteTemplate extends Component {
	@service('model-manager/users') declare mmUsersService: Service.ModelManager.Users;
	@service('account') declare accountService: Service.Account;

	get model() {
		if (this.accountService.hasPartnerResellerId) {
			return this.mmUsersService.activatedUserModels;
		} else {
			return this.mmUsersService.usersWithoutAgencyAdminsModels;
		}
	}

	@action
	createNewUser() {
		this.mmUsersService.checkToOpenInvitePopup('user-management');
	}

	<template>
		<AccountUsersTableComponent @model={{this.model}} @onAdd={{this.createNewUser}} />
	</template>
}
